<template>
  <!--
      作者：kmdshop
      时间：2020-07-10
      描述：插件中心-砍价-列表
    -->
  <div class="bargain-active-index">
    <!--搜索表单-->
    <div class="d-b-c">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="searchForm.search" placeholder="请输入用户昵称/用户ID"></el-input></el-form-item>
        <el-form-item label="">
            <el-select v-model="searchForm.status" @change="onSubmit" placeholder="请选择">
              <el-option label="进行中" :value="0">
              </el-option>
              <el-option label="已完成" :value="1">
              </el-option>
              <el-option label="全部" value="">
              </el-option>
            </el-select>
          </el-form-item>

        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="setting.name" label="活动名称"></el-table-column>
          <el-table-column prop="nickName" label="发起人" width="120"></el-table-column>
          <!-- <el-table-column prop="setting.num" label="推荐次数" width="120"></el-table-column> -->
          <el-table-column prop="num" label="已推荐人数" width="120"></el-table-column>
          <el-table-column prop="numun" label="差几人" width="150">
            <!-- <template slot-scope="scope">
             {{  (scope.row.setting.num-scope.row.num )<0?0:(scope.row.setting.num-scope.row.num)}}
            </template> -->
          </el-table-column>
          <!-- <el-table-column prop="setting.money" label="返利" width="150"></el-table-column> -->
          <!-- <el-table-column prop="aggregate_num" label="累计完成次数" width="150"></el-table-column> -->
          <el-table-column prop="product_name" label="产品" width="200">
            <template  slot-scope="scope">
              <div>{{scope.row.product.product.product_name}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="spec_val.spec_value" label="产品规格" width="70"> -->
            
          <!-- </el-table-column> -->
          <el-table-column prop="status_val" label="活动状态" width="150"></el-table-column>
          <el-table-column prop="update_time" label="创建时间" width="150"></el-table-column>

          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editsClick(scope.row.pushagainst_id)" type="text" size="small">参与人</el-button>
              <!-- <el-button @click="deleteClick(scope.row.bargain_activity_id)" type="text" size="small">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import PushagainstApi from '@/api/pushagainst.js'
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*搜索表单对象*/
      searchForm: {
        status:0
      },
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      PushagainstApi.list(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
        })
        .catch(error => {});
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*添加砍价活动*/
    addClick() {
      this.$router.push('/plus/bargain/active/add');
    },

    /*修改砍价活动*/
    editsClick(e) {
      let self = this;
      this.$router.push({
        path: '/plus/pushagainst/record/index',
        query: {
          pushagainst_id: e
        }
      });
    },

    /*删除砍价活动*/
    deleteClick(e) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          BargainApi.deleteBargain(
            {
              bargain_activity_id: e
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/pushagainst/pushagainst/index.vue